import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { LogMeInMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'
import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  description: `“We are dealing with millions and millions of end users across these products, so it’s critical not only to be able to get to the numbers, but to do so quickly and in a way that people who aren’t analysts but need that information can use it.”`,
  author: `Jon Borthwick`,
  role: `Director of Products, Identity & Access Management`,
}

const TestimonialComponent: FC = () => {
  const theme = useTheme()
  const pageConfig = usePageConfig()
  return (
    <StyledSectionBase variant="centered">
      <Section.Contents>
        <TestimonialBase variant="base">
          <Testimonial.Base height="auto">
            <Testimonial.BaseContentSlot>
              <Testimonial.BaseLogo>
                <LogMeInMonoLogo color={`${theme.palette.neutrals.white[`100`]}`} />
              </Testimonial.BaseLogo>
              <Testimonial.BaseText>{copy.description}</Testimonial.BaseText>
            </Testimonial.BaseContentSlot>
            <Testimonial.BaseAuthorSlot>
              <Testimonial.AuthorInfo>
                <Testimonial.AuthorName>{copy.author}</Testimonial.AuthorName>
                <Testimonial.AuthorPosition>{copy.role}</Testimonial.AuthorPosition>
              </Testimonial.AuthorInfo>
            </Testimonial.BaseAuthorSlot>
          </Testimonial.Base>
        </TestimonialBase>
        <ButtonWrapper>
          <ButtonText href={getAbsoluteUrl(`/customers/`, pageConfig)} tag="a" size="medium" iconEnd={ChevronRightIcon}>
            Read our customer stories
          </ButtonText>
        </ButtonWrapper>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
    ${Section.Contents} {
      max-width: 844px;
    }
  }
`

export const ButtonWrapper = styled.div`
  margin: 0 auto;
  text-align: center;
  padding-top: 40px;
`

export default TestimonialComponent
